import './deal-mini-chart.css'
import type { DealMiniHistory } from '@/lib/deals/mini-history'

/** No chart library, browser reads, invented flat lines or missing observations. */
export function DealMiniChart({ history }: { history?: DealMiniHistory }) {
  if (!history || history.kind !== 'chart') return <small>{history?.summary ?? 'Collecting 30-day price history'}</small>
  return (
    <>
      <small>30-day history; last observed {history.latestDate}{history.medianY !== null ? '; dashed 60-day median' : ''}</small>
      <svg className="dmh" viewBox="0 0 29 12" role="img" aria-label={history.summary}>
        <path d={history.path} />
        {history.medianY !== null ? <path d={`M0,${history.medianY}H29`} /> : null}
        <circle cx={history.latest[0]} cy={history.latest[1]} />
      </svg>
    </>
  )
}
